module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$store.state.is_auth) ? _c('div', {
    attrs: {
      "id": "w5-ticket-view-block"
    }
  }, [(!_vm.form_ErrorMessage) ? [_c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.localErrorMessage !== ''),
      expression: "localErrorMessage !== ''"
    }],
    staticClass: "alert alert-danger margin-top-10",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.localErrorMessage)) + "\n\t\t\t\t"), _c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": "close"
    },
    on: {
      "click": function($event) {
        _vm.localErrorMessage = ''
      }
    }
  }, [_vm._v("×")])])]), _vm._v(" "), (_vm.viewData && typeof _vm.viewData === 'object' && _vm.viewData['ticket']) ? _c('div', {
    staticClass: "w5-ticket-view-wrapper"
  }, [(_vm.UserType === 'admin') ? [(_vm.Ticket && _vm.Ticket['ticket_label']['value'] === 'loading') ? _c('div', {
    staticClass: "pull-left margin-top-5",
    staticStyle: {
      "height": "18px"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/loading-hor16.gif")
    }
  })]) : _c('div', {
    ref: "ticketLabel",
    staticClass: "pull-left margin-top-5 w5-list-ticket-label",
    class: _vm.ticketLabelClass,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTicketLabel($event)
      }
    }
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "w5-ticket-view-subject",
    class: _vm.UserType === 'admin' ? 'margin-left-6' : false
  }, [_vm._v(_vm._s(_vm.Ticket['ticket_subject']['value']))]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.UserType === 'client') ? _c('table', {
    staticClass: "w5-ticket-view-table"
  }, [_c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_code']['title'])) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.Ticket['ticket_code']['value']))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_status']['title'])) + ":")]), _vm._v(" "), _c('span', {
    style: ('color: ' + _vm.Ticket['ticket_status']['color'])
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.statusText))))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_created']['title'])) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_created']['value'], 'd.m.y H:M')))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-client"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_updated']['title'])) + ":")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_updated']['value'], 'd.m.y H:M')))])])])]) : _c('table', {
    staticClass: "w5-ticket-view-table"
  }, [_c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_code']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-2"
  }, [_c('span', [_vm._v(_vm._s(_vm.Ticket['ticket_code']['value']))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-3"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_created']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-4"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_created']['value'], 'd.m.y H:M')))])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_status']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-2"
  }, [_c('span', {
    style: ('color: ' + _vm.Ticket['ticket_status']['color'])
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.statusText))))])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-3"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Ticket['ticket_updated']['title'])) + ":")])]), _vm._v(" "), _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-4"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.Ticket['ticket_updated']['value'], 'd.m.y H:M')))])])]), _vm._v(" "), _c('tr', [(_vm.Department) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Department['name']['title'])) + ":")])]) : _vm._e(), _vm._v(" "), (_vm.Department) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-2"
  }, [(_vm.Department.access === true) ? _c('linkComponent', {
    staticClass: "can-select",
    attrs: {
      "url": '/department/view/' + _vm.Department['id']['value'],
      "text": _vm.Department['name']['value']
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.Department['name']['value']))])], 1) : _vm._e(), _vm._v(" "), (_vm.Account) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-3"
  }, [(_vm.Account.type === 'account') ? _c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['name']['title'])) + ":")]) : _vm._e(), _vm._v(" "), (_vm.Account.type === 'email' || _vm.Account.type === 'multi_info') ? _c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.Account['title'])) + ":")]) : _vm._e()]) : _c('td'), _vm._v(" "), (_vm.Account) ? _c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-4"
  }, [(_vm.Account.type === 'account') ? [(!_vm.Account['filter'] || _vm.Account['filter']['value'] != _vm.Account['id']['value']) ? _c('font-awesome-icon', {
    staticClass: "global-filter-button",
    attrs: {
      "title": _vm._f("ftc")('account/filter'),
      "icon": "filter"
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter(_vm.Account['id']['value'])
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.Account['filter'] && _vm.Account['filter']['value'] == _vm.Account['id']['value']) ? _c('font-awesome-layers', {
    staticClass: "global-filter-button global-filter-button-remove",
    attrs: {
      "title": _vm._f("ftc")('main/delete ' + _vm.localeFtc('main/filter').toLowerCase())
    },
    on: {
      "click": function($event) {
        return _vm.setAccountGlobalFilter()
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "filter"
    }
  }), _vm._v(" "), _c('font-awesome-icon', {
    attrs: {
      "icon": "times"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.Account.access === true) ? _c('linkComponent', {
    staticClass: "can-select",
    attrs: {
      "url": '/account/view/' + _vm.Account['id']['value'],
      "text": _vm.Account['name']['value']
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.Account['name']['value']))])] : _vm._e(), _vm._v(" "), (_vm.Account.type === 'email') ? [_c('span', {
    staticClass: "can-select",
    class: {
      'w5-link': _vm.Account.access === true
    },
    on: {
      "click": _vm.toCreateTicket
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm.Account['value']) + "\n\t\t\t\t\t\t\t")])] : _vm._e(), _vm._v(" "), (_vm.Account.type === 'multi_info') ? [_c('span', {
    staticClass: "can-select"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")(_vm.Account['value'])) + "\n\t\t\t\t\t\t\t")])] : _vm._e()], 2) : _c('td')]), _vm._v(" "), (_vm.MultiType) ? _c('tr', [_c('td', {
    staticClass: "w5-ticket-view-table-cell-admin-1"
  }, [_c('span', {
    staticClass: "w5-ticket-view-table-header"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.MultiType['title'])) + ":")])]), _vm._v(" "), (_vm.MultiTextValue && Array.isArray(_vm.MultiTextValue)) ? _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.MultiType['value'])) + " - ")]), _vm._v(" "), _vm._l((_vm.MultiTextValue), function(value, idx) {
    return [(idx > 0) ? [_vm._v(", ")] : _vm._e(), _vm._v(" "), (value['link'] === false || value['access'] === false) ? _c('span', {
      key: 'link-number-' + idx
    }, [_vm._v(_vm._s(_vm._f("ftc")(value['text'])))]) : _c('linkComponent', {
      key: 'link-number-' + idx,
      staticClass: "can-select",
      attrs: {
        "url": value['link'],
        "text": value['text']
      }
    })]
  })], 2) : _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.MultiType['value'])))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "margin-top-20"
  }, [(_vm.Window && _vm.Window.history && _vm.Window.history.length > 1) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.backButton
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/back')))]) : _c('button', {
    staticClass: "w5-ticket-view-button btn btn-default pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toTicketList
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/to_list')))]), _vm._v(" "), (_vm.canReplace && _vm.postPonseDepartmentId > 0 && (_vm.Department && _vm.Department.id && _vm.Department.id.value && _vm.Department.id.value != _vm.postPonseDepartmentId)) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit-danger pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.replaceTicketPendingConfirm
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "hourglass-half"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/postpone')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canBlock) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit-black pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.blockTicket
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "times-circle"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/blacklist')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canDelete) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit-black pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteTicket
    }
  }, [_c('font-awesome-icon', {
    staticClass: "color-red",
    attrs: {
      "icon": "times-circle"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/delete')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canReplace) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.replaceTicket
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "upload"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('department/department')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canAttach) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.attachTicket
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "download"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('account/account')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canSend) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.sendTicket
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "caret-square-right"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticket/sending')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.canMerge) ? _c('button', {
    staticClass: "w5-ticket-view-button btn btn-submit pull-left",
    staticStyle: {
      "width": "90px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.ticketMerge
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "compress-alt"
    }
  }), _vm._v("\n\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/merge')) + "\n\t\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeControl"
    }
  }, [(_vm.canAnswer) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.answerFormVisibility),
      expression: "answerFormVisibility"
    }]
  }, [(_vm.answerFormData && _vm.answerFormData.fields) ? _c('div', {
    ref: "answerForm",
    staticClass: "w5-form ticket-answer-form"
  }, [(_vm.$store.state.user_type === 'admin' && _vm.messageTypeField.list) ? _c('div', [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.messageTypeField.title)) + ":   ")]), _vm._v(" "), _c('span', {
    staticClass: "widget-link can-select",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeTypeMessage($event)
      }
    }
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.messageTypeField.list[_vm.messageTypeField.value]))))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.answerFormData.fields), function(row, index) {
    return (row) ? _c('div', {
      key: index,
      class: {
        'w5-form-row': _vm.isVisibleAnswerField(row)
      },
      style: (row[0]._field_name === 'files' ? 'width: 80%; float: left;' : false)
    }, [_vm._l((row), function(field) {
      return [(field.type === 'textarea') ? _c('Field', {
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleAnswerField(row),
          "crud": "ticketmessage",
          "action": "create",
          "Field": field,
          "removeRightPadding": true
        },
        on: {
          "input": _vm.onTextInput,
          "valueChanged": function($event) {
            return _vm.answerFieldChanged(field)
          },
          "focus": function($event) {
            return _vm.onFocusAnswer(field)
          },
          "answerTemplateDialog": _vm.showTemplateDialog
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      }) : _c('Field', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (field._field_name !== 'type'),
          expression: "field._field_name !== 'type'"
        }],
        key: field._field_name,
        attrs: {
          "isVisibleRow": _vm.isVisibleAnswerField(row),
          "crud": "ticketmessage",
          "action": "create",
          "Field": field,
          "removeRightPadding": field._field_name === 'files' || !_vm.needPadding
        },
        on: {
          "valueChanged": function($event) {
            return _vm.answerFieldChanged(field)
          },
          "focus": function($event) {
            return _vm.onFocusAnswer(field)
          }
        },
        model: {
          value: (field.value),
          callback: function($$v) {
            _vm.$set(field, "value", $$v)
          },
          expression: "field.value"
        }
      })]
    })], 2) : _vm._e()
  }), _vm._v(" "), _c('button', {
    ref: "submit_button",
    staticClass: "btn btn-submit btn-submit-green pull-right",
    class: {
      hidden: _vm.form_Loading
    },
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.blockAnswerForm === true || _vm.blockButtons === true ? 'disabled' : false
    },
    on: {
      "click": _vm.submitAnswerForm
    }
  }, [_vm._v("\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('main/send')) + "\n\t\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })], 2) : _vm._e()]) : _vm._e()])], 2) : _vm._e(), _vm._v(" "), (_vm.messagesData && typeof _vm.messagesData === 'object' && _vm.messagesData['title']) ? _c('div', {
    staticClass: "w5-ticket-view-wrapper"
  }, [_c('span', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "w5-ticket-view-subject",
    class: {
      'margin-top-10': !_vm.answerFormVisibility
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.messagesData['title'])))]), _vm._v(" "), _c('div', [(_vm.UserType === 'admin') ? _c('div', {
    staticClass: "form-inline"
  }, [_c('Field', {
    ref: "fastSearch",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "view",
      "name": "fastSearch",
      "Field": {
        _field_name: 'fastSearch',
        type: 'text',
        title: 'main/all_fields_search',
        '_visible': true
      },
      "removeRightPadding": true,
      "clearButton": true
    },
    on: {
      "event_ClearButtonClicked": _vm.fastSearchEvent,
      "fastSearchInput": _vm.fastSearchEvent
    },
    model: {
      value: (_vm.fastSearchValue),
      callback: function($$v) {
        _vm.fastSearchValue = $$v
      },
      expression: "fastSearchValue"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_total')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80"
  }, [_vm._v(_vm._s(_vm.messagesData.totalCount ? _vm.messagesData.totalCount : 0))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), _c('span', {
    staticClass: "font-size-80 font-weight-500 w5-ticket-view-widget"
  }, [_vm._v(_vm._s(_vm.localeFtc('main/sort_by').replace('{what}', _vm.$store.state.lang === 'en' ? 'date' : 'дате')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80 widget-link margin-right-0 can-select",
    on: {
      "click": _vm.msgSortChange
    }
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.msgSortFields[_vm.msgSort]['title']))))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  }), _vm._v(" "), (_vm.UserType === 'admin') ? [_c('span', {
    staticClass: "font-size-80 font-weight-500 w5-ticket-view-widget"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/filter')) + ": ")]), _vm._v(" "), _c('span', {
    staticClass: "font-size-80 widget-link margin-right-0 can-select",
    on: {
      "click": _vm.msgFilterChange
    }
  }, [_vm._v(_vm._s(_vm._f("lower")(_vm._f("ftc")(_vm.msgFilterFields[_vm.msgFilter]['title']()))))]), _vm._v(" "), _c('br', {
    staticClass: "visible-xs"
  })] : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "widget-page-size"
  }, [_c('span', {
    staticClass: "font-size-80 font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/list_size')) + ": ")]), _vm._v(" "), _vm._l((_vm.Config.pageSizes), function(size) {
    return _c('span', {
      key: 'page-size-id' + size,
      staticClass: "font-size-80 can-select",
      class: {
        'w5-link': size !== _vm.messagesData.pageSize, 'font-weight-500': size === _vm.messagesData.pageSize
      },
      on: {
        "click": function($event) {
          return _vm.setPageSize(size)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t " + _vm._s(size) + " \n\t\t\t\t\t\t")])
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.Ticket && _vm.messagesData && _vm.messagesData.rows && _vm.messagesData.rows.length) ? _c('div', {
    attrs: {
      "id": "w5-ticket-message-list"
    }
  }, [_vm._l((_vm.messagesData.rows), function(msg, idx) {
    return _c('div', {
      key: 'message-row-id-' + idx,
      staticClass: "ticket-message-wrapper",
      class: _vm.fromWhoClass(msg)
    }, [_c('div', {
      staticClass: "ticket-message-table-wrapper"
    }, [(msg['message_type'] === 'notice') ? _c('table', {
      staticClass: "w5-ticket-message-table",
      class: 'ticket-message-' + msg['message_type']
    }, [_c('tbody', [_c('tr', [_c('td', {
      staticClass: "ticket-message-notice-td-title font-weight-500"
    }, [_c('span', {
      staticClass: "margin-right-10"
    }, [_vm._v(_vm._s(_vm._f("date")(msg['message_created'], 'd.m.y H:M')))]), _vm._v(" "), (_vm.UserType === 'admin' && msg['user_id']) ? _c('linkComponent', {
      staticClass: "who can-select",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "url": (msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id'],
        "text": msg['user_name']
      }
    }) : _c('span', {
      staticClass: "who",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(msg['user_name'])))]), _vm._v(" "), ('user_online' in msg && msg['user_online'] === true && _vm.UserType === 'admin') ? _c('span', {
      staticClass: "online-status-is-on"
    }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (_vm.UserType === 'admin') ? _c('OpersButton', {
      attrs: {
        "message": msg,
        "status": _vm.Ticket['ticket_status']['value']
      },
      on: {
        "action": _vm.buttonMessageAction
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
      directives: [{
        name: "formatTicketMessage",
        rawName: "v-formatTicketMessage",
        value: ({
          'message': msg,
          'fastSearchValue': _vm.fastSearchValue
        }),
        expression: "{ 'message': msg, 'fastSearchValue': fastSearchValue }"
      }],
      staticClass: "ticket-message-content-text"
    })])]), _vm._v(" "), ((msg['message_time'] && _vm.UserType === 'admin') || (msg['message_mark'] || msg['can_mark'])) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-time-notice"
    }, [(msg['message_time'] && _vm.UserType === 'admin') ? _c('div', {
      staticClass: "time pull-left"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hourglass-half"
      }
    }), _vm._v(" " + _vm._s(_vm.MinutesToCountWord(msg['message_time'])))], 1) : _vm._e(), _vm._v(" "), (msg['message_mark']) ? _c('div', {
      staticClass: "ticket-message-mark pull-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticketmessage/mark')) + ": \n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      class: 'ticket-message-mark-' + (msg['message_mark'] === 'bad' ? 'bad' : 'good')
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": 'thumbs-' + (msg['message_mark'] === 'bad' ? 'down' : 'up')
      }
    })], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ('attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-attaches-notice"
    }, [_c('Attach', {
      attrs: {
        "attach": msg['attach'],
        "type": "notice"
      },
      on: {
        "preview": _vm.previewImage
      }
    })], 1)]) : _vm._e()])]) : (msg['message_type'] === 'normal' || msg['message_type'] === 'email') ? _c('table', {
      staticClass: "w5-ticket-message-table ticket-message-normal"
    }, [(msg['user_type'] === 'admin') ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "ticket-message-img",
      attrs: {
        "width": _vm.$store.state.windowWidth > 767 ? '80px' : '40px',
        "rowspan": "2",
        "align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + msg['user_avatar_path']
      }
    })]), _vm._v(" "), _c('td', {
      staticClass: "ticket-message-td-title"
    }, [('message_read' in msg && msg['message_read'] === true) ? _c('font-awesome-layers', {
      staticClass: "ticket-read margin-right-10"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "envelope"
      }
    }), _vm._v(" "), _c('font-awesome-icon', {
      attrs: {
        "icon": "check"
      }
    })], 1) : _c('font-awesome-layers', {
      ref: 'unread-message-' + msg['message_id'],
      refInFor: true,
      staticClass: "ticket-read margin-right-10"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "envelope"
      }
    }), _vm._v(" "), _c('font-awesome-icon', {
      attrs: {
        "icon": "asterisk"
      }
    })], 1), _vm._v(" "), (_vm.UserType === 'admin' && msg['user_id']) ? _c('linkComponent', {
      staticClass: "who can-select",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "url": (msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id'],
        "text": msg['user_name']
      }
    }) : _c('span', {
      staticClass: "who",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(msg['user_name'])))]), _vm._v(" "), ('user_online' in msg && msg['user_online'] === true && _vm.UserType === 'admin') ? _c('span', {
      staticClass: "online-status-is-on"
    }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (_vm.UserType === 'admin') ? _c('OpersButton', {
      attrs: {
        "message": msg,
        "status": _vm.Ticket['ticket_status']['value']
      },
      on: {
        "action": _vm.buttonMessageAction
      }
    }) : _vm._e(), _vm._v(" "), (_vm.UserType === 'client') ? _c('font-awesome-icon', {
      staticClass: "pull-right client-oper-button",
      attrs: {
        "title": _vm._f("ftc")('main/quote'),
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.quoteMessage(msg)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "margin-right-6 pull-right font-weight-500"
    }, [_vm._v(_vm._s(_vm._f("date")(msg['message_created'], 'd.m.y H:M')))])], 1)]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "ticket-message-td-message"
    }, [(msg['message_content_type'] === 'html') ? _c('p', {
      staticClass: "ticket-message-pre pre-admin ticket-message-content-text",
      domProps: {
        "innerHTML": _vm._s(msg['message_content'])
      }
    }) : _c('p', {
      directives: [{
        name: "formatTicketMessage",
        rawName: "v-formatTicketMessage",
        value: ({
          'message': msg,
          'fastSearchValue': _vm.fastSearchValue
        }),
        expression: "{ 'message': msg, 'fastSearchValue': fastSearchValue }"
      }],
      staticClass: "ticket-message-pre pre-admin ticket-message-content-text"
    })])]), _vm._v(" "), ((msg['message_time'] && _vm.UserType === 'admin') || msg['message_mark'] || (_vm.UserType !== 'admin' && msg['can_mark'] === true)) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-time",
      attrs: {
        "colspan": "2"
      }
    }, [(msg['message_time'] && _vm.UserType === 'admin') ? _c('div', {
      staticClass: "time pull-left"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hourglass-half"
      }
    }), _vm._v(" " + _vm._s(_vm.MinutesToCountWord(msg['message_time'])))], 1) : _vm._e(), _vm._v(" "), (msg['message_mark']) ? _c('div', {
      staticClass: "ticket-message-mark pull-right"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm._f("ftc")('ticketmessage/mark')) + ": \n\t\t\t\t\t\t\t\t\t\t\t"), _c('span', {
      class: 'ticket-message-mark-' + (msg['message_mark'] === 'bad' ? 'bad' : 'good')
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": 'thumbs-' + (msg['message_mark'] === 'bad' ? 'down' : 'up')
      }
    })], 1)]) : (_vm.UserType !== 'admin' && msg['can_mark'] === true) ? _c('div', {
      staticClass: "ticket-message-mark pull-right"
    }, [_c('span', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("ftc")('ticketmessage/get_mark')))]), _vm._v(" "), _c('span', {
      staticClass: "mark-button-bad",
      on: {
        "click": function($event) {
          return _vm.setMark(msg, 'bad')
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-down"
      }
    }), _vm._v("   " + _vm._s(_vm._f("ftc")('main/bad')))], 1), _vm._v(" "), _c('span', {
      staticClass: "mark-button-good",
      on: {
        "click": function($event) {
          return _vm.setMark(msg, 'good')
        }
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "thumbs-up"
      }
    }), _vm._v("   " + _vm._s(_vm._f("ftc")('main/good')))], 1)]) : _vm._e()])]) : _vm._e(), _vm._v(" "), ('attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-attaches-admin",
      attrs: {
        "colspan": "2"
      }
    }, [_c('Attach', {
      attrs: {
        "attach": msg['attach'],
        "type": "admin"
      },
      on: {
        "preview": _vm.previewImage
      }
    })], 1)]) : _vm._e()]) : (msg['user_type'] === 'user' || msg['user_type'] === 'unknown') ? _c('tbody', [_c('tr', [_c('td', {
      staticClass: "ticket-message-client-td-title"
    }, [('user_online' in msg && msg['user_online'] === true && _vm.UserType === 'admin') ? _c('span', {
      staticClass: "online-status-is-on pull-right"
    }, [_vm._v(" ●")]) : _vm._e(), _vm._v(" "), (_vm.UserType === 'admin' && msg['user_id']) ? _c('linkComponent', {
      staticClass: "who can-select",
      staticStyle: {
        "margin-right": "0"
      },
      attrs: {
        "url": (msg['user_type'] !== 'admin' ? '/user/view/' : '/admin/view/') + msg['user_id'],
        "text": msg['user_name']
      }
    }) : _c('span', {
      staticClass: "who",
      staticStyle: {
        "margin-right": "0"
      }
    }, [_vm._v(_vm._s(_vm._f("ftc")(msg['user_name'])))]), _vm._v(" "), (_vm.UserType === 'admin') ? _c('OpersButton', {
      attrs: {
        "message": msg,
        "status": _vm.Ticket['ticket_status']['value'],
        "toLeft": true
      },
      on: {
        "action": _vm.buttonMessageAction
      }
    }) : _vm._e(), _vm._v(" "), (_vm.UserType === 'client') ? _c('font-awesome-icon', {
      staticClass: "pull-left client-oper-button",
      attrs: {
        "title": _vm._f("ftc")('main/quote'),
        "icon": "copy"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.quoteMessage(msg)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "pull-left font-weight-500",
      style: (_vm.UserType === 'admin' ? 'margin-left: 6px' : 'margin-left: 11px')
    }, [_vm._v(_vm._s(_vm._f("date")(msg['message_created'], 'd.m.y H:M')))])], 1), _vm._v(" "), _c('td', {
      staticClass: "ticket-message-img",
      attrs: {
        "width": _vm.$store.state.windowWidth > 767 ? '80px' : '40px',
        "rowspan": "3",
        "align": "center"
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.APIServerUrl + msg['user_avatar_path']
      }
    })])]), _vm._v(" "), _c('tr', [_c('td', {
      staticClass: "ticket-message-client-td-message"
    }, [_c('p', {
      directives: [{
        name: "formatTicketMessage",
        rawName: "v-formatTicketMessage",
        value: ({
          'message': msg,
          'fastSearchValue': _vm.fastSearchValue
        }),
        expression: "{ 'message': msg, 'fastSearchValue': fastSearchValue }"
      }],
      staticClass: "ticket-message-pre pre-client ticket-message-content-text"
    })])]), _vm._v(" "), (msg['message_time']) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-time",
      attrs: {
        "colspan": "2"
      }
    }, [_c('div', {
      staticClass: "time pull-right"
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "hourglass-half"
      }
    }), _vm._v(" " + _vm._s(_vm.MinutesToCountWord(msg['message_time'])))], 1)])]) : _vm._e(), _vm._v(" "), ('attach' in msg && msg['attach'] && Array.isArray(msg['attach']) && msg['attach'].length) ? _c('tr', [_c('td', {
      staticClass: "ticket-message-td-attaches-client",
      attrs: {
        "colspan": "2"
      }
    }, [_c('Attach', {
      attrs: {
        "attach": msg['attach'],
        "type": "client"
      },
      on: {
        "preview": _vm.previewImage
      }
    })], 1)]) : _vm._e()]) : _vm._e()]) : _vm._e()])])
  }), _vm._v(" "), (_vm.Ticket && _vm.paginationPages.length > 0) ? _c('div', [_c('paginator', {
    attrs: {
      "baseUrl": '/ticket/view/' + _vm.ticketId,
      "pages": _vm.paginationPages,
      "curPage": _vm.page,
      "lastPage": _vm.lastPage
    }
  })], 1) : _vm._e()], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteModal),
      expression: "showDeleteModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/deleting')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.deleteModalText)),
      expression: "localeFtc(deleteModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.deleteTicketStart
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDeleteMessageModal),
      expression: "showDeleteMessageModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteMessageModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_delete')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showDeleteMessageModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketmessage/delete_request')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.deleteTicketMessageStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_delete')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEmailModal),
      expression: "showEmailModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showEmailModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/blacklist')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showEmailModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.emailModalText)),
      expression: "localeFtc(emailModalText)"
    }],
    staticClass: "padding-0-5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.blockEmailTicketStart
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showReplaceModal),
      expression: "showReplaceModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showReplaceModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showReplaceModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "ticketMoveModalSelectDepartment",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "view",
      "name": "ticketMoveModalSelectDepartment",
      "listInModal": true,
      "listBlockToOut": 1,
      "fieldInModal": true,
      "Field": _vm.replaceField,
      "removeRightPadding": true
    },
    model: {
      value: (_vm.replaceValue),
      callback: function($$v) {
        _vm.replaceValue = $$v
      },
      expression: "replaceValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.replaceTicketStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticketrule/action_move')))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAttachModal),
      expression: "showAttachModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showAttachModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/assing_account')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showAttachModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "ticketAttachModalSelectAccount",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "view",
      "name": "ticketAttachModalSelectAccount",
      "Field": _vm.attachField,
      "removeRightPadding": true,
      "listInModal": true,
      "listBlockToOut": 1,
      "fieldInModal": true
    },
    on: {
      "focus": function($event) {
        _vm.attachField['_errMsg'] = ''
      }
    },
    model: {
      value: (_vm.attachValue),
      callback: function($$v) {
        _vm.attachValue = $$v
      },
      expression: "attachValue"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.attachTicketStart
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSendModal),
      expression: "showSendModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showSendModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/sending_start')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showSendModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/sending_start_confirm')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    on: {
      "click": _vm.sendTicketStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/sending_start')))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPreviewModal),
      expression: "showPreviewModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showPreviewModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    style: ('width:' + _vm.modalPreviewWidth + 'px;'),
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalPreviewText)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showPreviewModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('img', {
    ref: "previewImageInDialog",
    style: (_vm.modalPreviewStyle)
  }), _vm._v(" "), (_vm.modalPreviewIsGallery) ? _c('div', {
    staticClass: "image-arrow prev",
    on: {
      "click": function($event) {
        return _vm.galleryMove(-1)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-left"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.modalPreviewIsGallery) ? _c('div', {
    staticClass: "image-arrow next",
    on: {
      "click": function($event) {
        return _vm.galleryMove(+1)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "arrow-right"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "w5-preview-in-dialog-text"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.modalPreviewTitle)))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(" (" + _vm._s(_vm.modalPreviewSize) + ")")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-submit w5-file-uploader-load-button pull-right",
    attrs: {
      "href": _vm.modalPreviewUrl
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/download')))])])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showTemplateModal),
      expression: "showTemplateModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container ticket-template",
    on: {
      "click": _vm.filterModalContainers
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('text/find_templates')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.hideTemplateModal
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('textSearch', {
    ref: "textSearchTemplateDialog",
    attrs: {
      "Field": _vm.templateField
    },
    on: {
      "textSelected": _vm.templateChoiced
    }
  })], 1)])])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMergeTicketsDialog),
      expression: "showMergeTicketsDialog"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showMergeTicketsDialog')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")('ticket/merge')))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showMergeTicketsDialog')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "w5-form-row"
  }, [_c('Field', {
    ref: "mergeTicketsSelectTicket",
    attrs: {
      "isVisibleRow": true,
      "crud": "ticket",
      "action": "list",
      "name": "mergeTicketsSelectTicket",
      "listBlockToOut": 1,
      "listInModal": true,
      "fieldInModal": true,
      "Field": _vm.mergeTicketsField,
      "removeRightPadding": true
    },
    on: {
      "focus": function($event) {
        _vm.mergeTicketsField._errMsg = ''
      }
    },
    model: {
      value: (_vm.mergeTicketsField.value),
      callback: function($$v) {
        _vm.$set(_vm.mergeTicketsField, "value", $$v)
      },
      expression: "mergeTicketsField.value"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit pull-right",
    on: {
      "click": _vm.mergeTicketsStart
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/continue')))])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showChoiceTicketLabelBlock),
      expression: "showChoiceTicketLabelBlock"
    }],
    ref: "ticketChoiceLabelBlock",
    staticClass: "widget-filter-ticket-label-choice",
    style: (_vm.ticketLabelBlockStyle)
  }, _vm._l((_vm.ticketLabelItems), function(val, idx) {
    return (String(val) !== '') ? _c('div', {
      key: 'label-choice-id-' + idx,
      staticClass: "w5-list-ticket-label cursor-pointer",
      class: 'ticket-label-color-' + String(val).toLowerCase(),
      on: {
        "click": function($event) {
          return _vm.onChangeTicketLabel(val)
        }
      }
    }) : _vm._e()
  }), 0), _vm._v(" "), _c('span', {
    ref: "quoteBlockWrapper",
    staticClass: "quote-selected-text-menu",
    attrs: {
      "id": "quoteBlockWrapper"
    },
    on: {
      "click": _vm.selectedTextToQuote
    }
  }, [_c('span', {
    ref: "quoteBlock",
    attrs: {
      "id": "quoteBlock"
    }
  }, [_vm._v(_vm._s(_vm._f("ftc")('main/quote')))])]), _vm._v(" "), (_vm.$store.state.user_type === 'client') ? _c('div', {
    staticClass: "review-block",
    class: {
      'active': _vm.reviewBlockShow
    }
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "aria-label": "close",
      "title": "close"
    },
    on: {
      "click": function($event) {
        _vm.reviewBlockShow = false
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "review-block-link"
  }, [_c('span', [_vm._v(_vm._s(_vm.reviewBlockText(1)))]), _vm._v(" "), (_vm.AppName === 'vdsina') ? _c('a', {
    attrs: {
      "href": "https://vdsina.ru/qa/q/gde-mozhno-ostavit-otzyv-o-vdsinaru",
      "target": "_blank",
      "rel": "nofollow noopener",
      "title": _vm._f("ftc")('main/review_link_title')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.reviewBlockText(2)) + "\n\t\t\t\t")]) : _vm._e(), _vm._v(" "), (_vm.AppName === 'vdsina.com') ? _c('a', {
    attrs: {
      "href": _vm.$store.state.lang === 'en' ? 'https://www.vdsina.com/qa/q/where-can-i-leave-a-review-about-vdsinacom' : 'https://www.vdsina.com/ru/qa/q/gde-mozhno-ostavit-otzyv-o-vdsinacom',
      "target": "_blank",
      "rel": "nofollow noopener",
      "title": _vm._f("ftc")('main/review_link_title')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.reviewBlockText(2)) + "\n\t\t\t\t")]) : (_vm.AppName === 'macloud') ? _c('a', {
    attrs: {
      "href": "https://macloud.ru/qa/q/gde-mozhno-ostavit-otzyv-o-macloudru",
      "target": "_blank",
      "rel": "nofollow noopener",
      "title": _vm._f("ftc")('main/review_link_title')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.reviewBlockText(2)) + "\n\t\t\t\t")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmModal),
      expression: "showConfirmModal"
    }],
    staticClass: "modal-mask",
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showConfirmModal')
      }
    }
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container ticket-template",
    on: {
      "click": _vm.filterModalContainers
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "font-weight-500"
  }, [_vm._v(_vm._s(_vm._f("ftc")(_vm.confirmModalTitle)))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.hideModalDialog('showConfirmModal')
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('span', {
    directives: [{
      name: "withSafeTags",
      rawName: "v-withSafeTags",
      value: (_vm.localeFtc(_vm.confirmModalContent)),
      expression: "localeFtc(confirmModalContent)"
    }],
    staticStyle: {
      "padding": "0",
      "margin": "0"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('span', {
    staticClass: "btn btn-submit btn-submit-danger pull-right",
    attrs: {
      "disabled": _vm.modalTimer && _vm.modalTimer > 0 ? 'disabled' : false
    },
    on: {
      "click": _vm.confirmModalFunc
    }
  }, [_vm._v(_vm._s(_vm.modalButtonTitle))])])])])])])] : _c('errorAlert', {
    attrs: {
      "message": _vm.form_ErrorMessage
    }
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45ccc689"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/crud/TicketView.vue
// module id = 702
// module chunks = 0